import { createFileRoute } from "@tanstack/react-router";
import { TimeOffFeature } from "@/features/time-off";

function TimeOffPage() {
  return <TimeOffFeature />;
}

export const Route = createFileRoute("/scheduler/time-off/")({
  component: TimeOffPage,
  staticData: { authorize: true },
});
